<script>
import BtnOptions from '../../../_default/components/BtnOptions'
import PopupViewer from '../../../_default/components/popup-viewer/PopupViewer'
import ConfiguracaoUsuarioAcl from './ConfiguracaoUsuarioACL'
import UsuarioPatios from './UsuarioPatios'
import UsuarioContratos from './UsuarioContratos'

export default {
  name: 'BtnUsuarioConfiguracoesGerenciais',
  components: {
    UsuarioContratos,
    UsuarioPatios,
    ConfiguracaoUsuarioAcl,
    PopupViewer,
    BtnOptions
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showConfiguracaoACL: false,
      showRelacionarUsuarioPatio: false,
      showRelacionarUsuarioContrato: false,
      options: [
        {
          acl: 'editar_acl_usuario',
          emit: 'openConfiguracoesACL',
          label: 'Ver/Configurar ACL'
        },
        {
          acl: 'editar_acesso_usuario_patios',
          emit: 'openConfiguracaoAcessoPatio',
          label: 'Gerenciar acesso a pátios'
        },
        {
          acl: 'editar_acesso_usuario_contratos',
          emit: 'openConfiguracaoAcessoContrato',
          label: 'Gerenciar acesso a contratos'
        },
        {
          acl: 'cadastrar_codigo_sequencial_atendente',
          emit: 'openAtendenteReboquistaForm',
          label: 'Configurar sequencial para atendente da Polícia Civil',
          icon: 'cog'
        }
      ]
    }
  },
  methods: {
    openConfiguracaoACL () {
      this.showConfiguracaoACL = true
    },
    closeConfiguracaoACL () {
      this.showConfiguracaoACL = false
    },
    openRelacionarUsuarioPatio () {
      this.showRelacionarUsuarioPatio = true
    },
    closeRelacionarUsuarioPatio () {
      this.showRelacionarUsuarioPatio = false
    },
    openRelacionarUsuarioContrato () {
      this.showRelacionarUsuarioContrato = true
    },
    closeRelacionarUsuarioContrato () {
      this.showRelacionarUsuarioContrato = false
    }
  }
}
</script>

<template>
  <div>
    <btn-options
      title="Configurações gerenciais de usuário"
      :options="options"
      @openConfiguracoesACL="openConfiguracaoACL"
      @openConfiguracaoAcessoPatio="openRelacionarUsuarioPatio"
      @openConfiguracaoAcessoContrato="openRelacionarUsuarioContrato"
      @openAtendenteReboquistaForm="$emit('openAtendenteReboquistaForm')"
    ></btn-options>

    <popup-viewer v-if="showConfiguracaoACL" @close="closeConfiguracaoACL" :title="`Configuração de ACL de ${user.username}`">
      <configuracao-usuario-acl :acls="user.acl"></configuracao-usuario-acl>
    </popup-viewer>

    <popup-viewer title="Gerenciar pátios do usuário" v-if="showRelacionarUsuarioPatio" @close="closeRelacionarUsuarioPatio">
      <usuario-patios :patios-usuario="user.patios"></usuario-patios>
    </popup-viewer>

    <popup-viewer title="Gerenciar contratos do usuário" v-if="showRelacionarUsuarioContrato" @close="closeRelacionarUsuarioContrato">
      <usuario-contratos :contratos-usuario="user.contratos"></usuario-contratos>
    </popup-viewer>
  </div>
</template>



// WEBPACK FOOTER //
// BtnUsuarioConfiguracoesGerenciais.vue?0b667c8c